import { RealEstateOwnerDto } from "api/real-estate"
import { Button } from "components/ui/Button"
import { CommercialIcon, ManIcon } from "components/icons/customIcons"
import { EyeIcon } from "components/icons/Icons"
import { NsKey } from "enums/NsKey"
import { useDynamicTranslation } from "hooks/useDynamicTranslation"
import { FC, useCallback } from "react"
import { usePanel } from "hooks/usePanel"
import { Sizes } from "enums/sizes"
import PersonOverviewById from "features/person-view/components/PersonOverviewById"

interface RealEstateOwnerSectionProps {
  owners: RealEstateOwnerDto[]
}

export const RealEstateOwnerSection: FC<RealEstateOwnerSectionProps> = ({ owners }) => {
  const { t } = useDynamicTranslation([NsKey.RealEstate])
  const { openPanel } = usePanel();

  const openPersonDetails = useCallback((name: string, id: string) => {
    openPanel(
      {
        title: name,
        size: Sizes.xl
      },
      <PersonOverviewById personId={id} />
    );
  }, [openPanel]);

  return <div className="space-y-4">
    <h3 className="text-lg font-semibold">{t('REAL_ESTATE.LABELS.OWNERS')}</h3>
    <div className="space-y-2">
      {
        owners.map((owner, index) => (
          <div
            key={`${owner.id}-${index}`}
            className="border text-sm rounded-2xl bg-white px-4 py-2 shadow flex items-center"
          >
            <div className="grid grid-cols-12 gap-4 divide-x w-full">
              <div className="col-span-3 flex items-center gap-4">
                {owner.type === 'legal' ? <CommercialIcon className="text-primary w-6" /> : <ManIcon />}
                {owner.displayName}
              </div>
              <div className="col-span-3 px-4 flex items-center">
                <div className="text-primary">
                  {owner.email}
                </div>
              </div>
              <div className="col-span-2 px-4 flex items-center">
                <div className="text-primary">
                  {owner.phone}
                </div>
              </div>
              <div className="col-span-4 px-4 flex items-center">
                <div className="space-x-2">
                  <span className="text-gray-600">Forme juridique</span>
                  <span className="text-primary">
                    {owner.type === 'legal' ? 'Personne morale' : 'Personne physique'}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-end">
              <Button
                round
                color='slate'
                onClick={() => owner.id && openPersonDetails(owner.displayName, owner.id)}
              >
                <EyeIcon className="w-5 h-5" />
              </Button>
            </div>
          </div>
        ))
      }
    </div>
  </div>
}
